/* eslint-disable jsx-a11y/anchor-is-valid */
import { Collapse, createStyles, Button, Modal } from "@mantine/core";
import { GetTranslated, TranslateField } from "../types/translate-field";
import { useState } from "react";
import { CurrentLocale } from "../App";
import { Link } from "react-router-dom";

const useStyles = createStyles((theme) => ({

    imageWrap: {
        width: '100%',
        height: 300,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundColor: '#F5F5F5',
        backgroundBlendMode: 'darken',
        display: 'flex',
        alignItems: 'end'
    },

    a: {
        padding: 0,
        height: 300,
        color: '#353e55',
        fontSize: '14px',
        fontWeight: 300,
        width: '100%',
        textDecoration: 'unset'
    },

    title: {
        whiteSpace: 'break-spaces',
        color: theme.colors.offWhite[1],
        textAlign: 'center',
        // fontWeight: 500,
        fontSize: 14,
        backgroundColor: 'rgb(50, 50, 50, .7)',
        margin: 0,
        padding: '5px 20px',
    },

    cardWrap: {
        height: 'auto',
        // width: '200px',
        margin: 'auto',
        display: 'flex',
        flexFlow: 'row',
        border: '1px solid rgba(220, 220, 220, 1)',
        boxShadow: '0px 2px 10px rgba(229, 229, 235, 0.4)',
        backgroundColor: '#ffffff',
        borderRadius: 0,
        transition: 'transform 0.2s',
        overflow: 'visible',
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0px 2px 15px rgba(229, 229, 235, 0.6)',
        }
    },
    cardBody: {
        // padding: '0px 16px 8px 16px',
        height: '100%',
        width: '100%',
        justifyContent: 'end',
        display: 'flex',
        flexFlow: 'column',
    }
}))

export interface ProductCardProp {
    link: string
    slug: string
    key: string
    title: string
    translation?: TranslateField
    isProduct?: boolean
    subCat?: string
    modal?: boolean
    display_order: number
}

const ProductCard = (props: { prop: ProductCardProp, className?: string, showArrowButton?: boolean }) => {
    const { classes } = useStyles()
    const [modal, setModal] = useState(false)

    const cardProp = props.prop
    const locale = CurrentLocale ?? 'en'

    const useModal = props.prop.modal ?? false
    const useLink = !props.prop.isProduct ?? true

    const [open, toggleOpen] = useState(false)

    return (
        <div className={`${classes.cardWrap} ${props.className ?? ''}`}>
            {
                // props.loading && props.loading ?
                //     <Skeleton height={359} /> :
                useModal ?
                    <div className={classes.a} onClick={() => setModal(true)}>
                        <div className={classes.imageWrap} style={{ backgroundImage: `url(${cardProp.link})` }}>
                            <div className={classes.cardBody}>
                                <p className={classes.title}>
                                    {
                                        props.prop.translation ?
                                            GetTranslated(props.prop.translation, locale)
                                            :
                                            cardProp.title
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    :
                    useLink ?
                        <Link to={cardProp.subCat!} key={cardProp.key} style={{width: '100%'}} className={classes.a}>
                            <div className={classes.imageWrap} style={{ backgroundImage: `url(${cardProp.link})` }}>
                                <div className={classes.cardBody}>
                                    <p className={classes.title}>
                                        {
                                            props.prop.translation ?
                                                GetTranslated(props.prop.translation, locale)
                                                :
                                                cardProp.title
                                        }
                                    </p>
                                </div>
                            </div>
                        </Link>
                        :
                        <Link to={cardProp.subCat ?? '#'} key={cardProp.key} className={classes.a}>
                            <div className={classes.imageWrap} style={{ backgroundImage: `url(${cardProp.link})` }} onMouseOver={() => toggleOpen(true)} onMouseOut={() => toggleOpen(false)}>
                                <div className={classes.cardBody}>
                                    <Collapse in={open}>
                                        <p className={classes.title}>
                                            {
                                                cardProp.translation ?
                                                    GetTranslated(cardProp.translation, locale)
                                                    :
                                                    cardProp.title
                                            }
                                        </p>
                                        <p className={classes.title}>
                                            {`SKU: ${cardProp.slug.toLowerCase().replace('s', '')}`}
                                        </p>
                                    </Collapse>
                                </div>
                            </div>
                        </Link>
            }
            <Modal centered opened={modal} onClose={() => setModal(false)}>
                <div className={classes.imageWrap} style={{ backgroundImage: `url(${cardProp.link})`, height: 600 }} onMouseOver={() => toggleOpen(true)} onMouseOut={() => toggleOpen(false)}>
                    <div className={classes.cardBody}>
                        <p className={classes.title}>
                            {
                                cardProp.translation ?
                                    GetTranslated(cardProp.translation, locale)
                                    :
                                    cardProp.title
                            }
                        </p>
                        <p className={classes.title}>
                            {`SKU: ${cardProp.slug.toLowerCase().replace('s', '')}`}
                        </p>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ProductCard;